'use strict';

angular.module('portal.linkpage', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // portal routings
            // link page
            .state('portal.menus.linkpage', {
                url: '/linkpage/:id',
                templateUrl: paths.app + 'link-page/components/link-page/link-page.html',
                controller: 'LinkPage',
                params: {
                    id: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
    }])
    ;